import { render, staticRenderFns } from "./UsersAndPermissionComponent.vue?vue&type=template&id=1d2ffc44&scoped=true&"
import script from "./UsersAndPermissionComponent.vue?vue&type=script&lang=js&"
export * from "./UsersAndPermissionComponent.vue?vue&type=script&lang=js&"
import style0 from "./UsersAndPermissionComponent.vue?vue&type=style&index=0&id=1d2ffc44&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d2ffc44",
  null
  
)

export default component.exports